import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite, Alert } from '../../hybrid/wrappers';
import css from './content-alert.module.scss';
import classNames from 'classnames';
import { generateCompStylers } from '../../common/utils/styles';

const ContentAlert = ({ showMessage, setShowAlert, message, type, icon, compStyles, title }) => {
    if (!showMessage && setShowAlert) return null;

    const { stylers, classes } = generateCompStylers(compStyles);
    return (
        <Alert
            setShowAlert={setShowAlert}
            type={type}
            compStyles={{
                ...compStyles,
                wrapper: {
                    ...stylers.wrapper,
                    className: classNames(classes.wrapper)
                },
                crossWrapper: {
                    ...stylers.crossWrapper,
                    className: classNames(classes.crossWrapper, css.crossWrapper)
                }
            }}
        >
            {title ? <p className={css.alertTitle}>{title}</p> : null}
            <div className={css.textWrapWeb}>
                {typeof message === 'string' ? (
                    <p style={stylers.message} className={classes.message || ''}>
                        {message}
                        {!!icon && svgSprite(icon, { className: css.alertErrorIcon })}
                    </p>
                ) : (
                    <div className={compStyles?.message || ''}>
                        {message}
                        {!!icon && svgSprite(icon, { className: css.alertErrorIcon })}
                    </div>
                )}
            </div>
        </Alert>
    );
};

ContentAlert.propTypes = {
    styles: PropTypes.object,
    showMessage: PropTypes.bool,
    setShowAlert: PropTypes.func,
    message: PropTypes.node,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
    icon: PropTypes.string
};

export default ContentAlert;
